import styled from 'styled-components';
import { SearchInputExpanded } from '../../atoms/input/search-input-expanded';

const Wrapper = styled.div`
  padding: var(--spacing-02);
`;

export const Control = (props) => {
  return (
    <Wrapper>
      <SearchInputExpanded
        value={props.selectProps.inputValue}
        onChange={(e) =>
          props.selectProps.onInputChange(e.target.value, {
            action: 'input-change',
          })
        }
        onClear={() =>
          props.selectProps.onInputChange('', {
            action: 'input-change',
          })
        }
      />
    </Wrapper>
  );
};
